package com.macrofocus.eflux.components.link

import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px
import web.url.URL

external interface DMZUWHSZLinkProps : Props {
    var url: String?
    var link: Boolean?
}

val DMZUWHSZLink = FC<DMZUWHSZLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        if(props.link != true) {
            component = Button
        } else {
            href = props.url
        }
        onClick = {
            if(props.url != null) {
                window.open(props.url!!, "_blank")
            }
        }

        if(props.link == true) {
            +extractMachineName(props.url)
        } else {
            +"DMZUWHSZ"
        }
    }
}

fun extractMachineName(urlString: String?): String? {
    if(urlString == null) return null
    val url = URL(urlString)
    return url.hostname.substringBefore(".")
}

fun extractHostname(urlString: String?): String? {
    if(urlString == null) return null
    val url = URL(urlString)
    return url.hostname
}